export const variablesInputfields = [
  {
    name: 'hectares',
    label: 'Hectares ',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
    isEditable: true,
  },
  {
    name: 'treesPerHectare',
    label: 'Trees/Hectares',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
    isEditable: true,
  },
  {
    name: 'averageTree',
    label: 'Ave Tree Volume',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
    isEditable: true,
  },
  {
    name: 'conversionFactor',
    label: 'Conversion Factor',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
    isEditable: true,
  },
  {
    name: 'm3PerHectare',
    label: 'M³ / Hectares',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
  },
  {
    name: 'tonnesPerHectare',
    label: 'Tons / Hectares',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
  },
  {
    name: 'totalM3',
    label: 'Total M³',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
  },
  {
    name: 'totalTons',
    label: 'Total Tons',
    typeOfInp: 'input',
    textFieldType: 'number',
    isTextArea: false,
    width: 1.156,
    helperText: '',
    required: false,
  },
];

export const DEFAULT_TABLE_LEFT_SIDE_LABEl = [
  { key: 'salesPrice', label: 'Sales Price/Ton' },
  { key: 'chipping', label: 'Chipping/Ton' },
  { key: 'doubleHandling', label: 'Double Handling/Ton' },
  { key: 'destination', label: 'Destination' },
  { key: 'haulageCategory', label: 'Haulage Category' },
  { key: 'haulage', label: 'Haulage/Ton' },
  { key: 'extractionCosts', label: 'Extraction Costs/Ton' },
  { key: 'harvestingCostsPerTonne', label: 'Harvesting Cost/Ton' },
  { key: 'purchasesPrice', label: 'Purchase Price/Ton' },
];

export const LOCATIONS = [
  'Graingers',
  'Ballon',
  'Ballygar',
  'Coolrain',
  'Laois Sawmills',
  'ECC',
  'Balcas',
  'McHugh',
  'Woodfarm',
  'Aurivo',
  'Bord na Mona',
  'Masonite',
  'Killenure Yard',
  'French Park',
  'Shamrock Renewables',
  'Other',
  'Glennon',
  'Palfab',
];

export const DEFAULT_LPG_RATE_OPTIONS = [
  {
    key: '1.2',
    label: '1.2 €',
    name: 'rateA',
  },
  {
    key: '1.3',
    label: '1.3 €',
    name: 'rateB',
  },
  {
    key: '1.4',
    label: '1.4 €',
    name: 'rateC',
  },
];
